<template>
  <div :class="expirationClass(stock)" v-if="stock.item.trackExpirationDate && stock.expiryAsDate">{{ $d(stock.expiryAsDate, 'dateonly') }}</div>
</template>

<script setup lang="ts">
import ITrackableStock from "@/models/ITrackableStock";

const props = defineProps({
  stock: { type: Object as () => ITrackableStock, required: true },
  ignoreLeadTime: { type: Boolean, required: false, default: false },
});

function expirationClass(stockChange: ITrackableStock) {
  return {
    'bg-danger text-light': stockChange.expiryExceeded,
    'bg-warning text-dark': !props.ignoreLeadTime && !stockChange.expiryExceeded && stockChange.expiryLeadTimeReached
  };
}
</script>
